import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { nonEmpty } from "../../../swzutils";
const AddressFormatted = ({ address }) => {
    if (!address) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [nonEmpty `${address.unitOrFlat} ${address.street} ${address.suburb}`, _jsx("br", {}), nonEmpty `${address.suburb} ${address.state} ${address.postcode}`, _jsx("br", {})] }));
};
export default AddressFormatted;
